import { AppState } from '@nxsys/store';
import { showCurrencyByCountry } from '@nxsys/utils';
import { useSelector } from 'react-redux';

const AppIconCurrency = () => {
  const { payrollCountry } = useSelector((state: AppState) => state.appStore);

  return (
    <div className="w-[20px] h-[20px] border-[2px] border-neutral-500 rounded-[4px] bg-[#F9FBFA] text-center leading-1 text-neutral-500">
      {showCurrencyByCountry(payrollCountry)}
    </div>
  );
};

export default AppIconCurrency;
